// src/components/cart/CartItems.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { Trash2 } from 'lucide-react';

const CartItems = ({ cartItems, updateQuantity, removeItem }) => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <motion.div variants={containerVariants} initial="hidden" animate="visible">
      {!cartItems.length ? (
        <p className="text-gray-400 dark:text-gray-100 text-lg">Your cart is empty.</p>
      ) : (
        cartItems.map(item => {
          const itemKey = `${item.name}-${item.size}-${item.color}`;
          return (
            <div
              key={itemKey}
              className="flex items-center p-4 border border-[#DBAE6E] mb-4 rounded-lg bg-primary dark:bg-primary-dark"
            >
              <img
                src={item.images?.[item.color]?.[0]}
                alt={item.name}
                className="w-24 h-24 object-cover mr-4 rounded"
                onError={e => (e.target.src = '/fallback-image.jpg')}
              />
              <div className="flex-1">
                <h3 className="text-xl text-black dark:text-white font-semibold">{item.name}</h3>
                <p className="text-sm text-gray-400 dark:text-gray-100">Size: {item.size}, Color: {item.color}</p>
                <p className="text-lg text-[#DBAE6E] font-bold">
                  INR {item.declaredValue.toFixed(2)}
                </p>
                <div className="flex items-center gap-3 mt-3">
                  <button
                    onClick={() => updateQuantity(item, -1)}
                    className="bg-[#DBAE6E] text-black w-8 h-8 rounded-full"
                    disabled={item.quantity <= 1}
                  >
                    -
                  </button>
                  <span className="text-lg text-black dark:text-white">{item.quantity}</span>
                  <button
                    onClick={() => updateQuantity(item, 1)}
                    className="bg-[#DBAE6E] text-black w-8 h-8 rounded-full"
                  >
                    +
                  </button>
                  <button
                    onClick={() => removeItem(itemKey)}
                    className="text-red-500 hover:text-red-400 ml-2"
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            </div>
          );
        })
      )}
    </motion.div>
  );
};

export default CartItems;